import React from 'react';
import { IconButton, IconType } from 'features/nekst-widgets';
import { useShareDocumentButton } from 'features/tasks-forms';

export default function ShareDocumentButton() {
  const { onClick, isGranted, isCopied } = useShareDocumentButton(
    (text: string) => {
      navigator.clipboard.writeText(text);
    }
  );

  if (isGranted) {
    if (isCopied) {
      return (
        <span
          style={{
            color: '#53ac61',
            fontSize: '12px',
          }}
        >
          Link Copied
        </span>
      );
    } else {
      return (
        <IconButton
          onClick={onClick}
          type={IconType.SHARE}
          title="Share Document"
        />
      );
    }
  } else {
    return null;
  }
}
